var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Navbar"),
      _vm._v(" "),
      _c(
        "main",
        [
          _c("FullLoader", { attrs: { loading: _vm.createLoading } }),
          _vm._v(" "),
          _c("div", { staticClass: "container create-prize-container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 d-flex justify-content-between align-items-center page-header"
                },
                [
                  _c("img", {
                    staticClass: "header-action cancel",
                    attrs: { src: require("@/assets/images/x.svg") },
                    on: {
                      click: function($event) {
                        return _vm.backToDashboard()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("h1", [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.event_name) +
                        "\n            "
                    ),
                    _c("img", {
                      staticClass: "path-separator",
                      attrs: {
                        src: require("@/assets/images/path_separator.svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Prizes")]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "path-separator",
                      attrs: {
                        src: require("@/assets/images/path_separator.svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "new" }, [
                      _vm._v(_vm._s(_vm.prizeText))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "desktop" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          click: function($event) {
                            return _vm.validate()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.prizeAction))]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-6" }, [
                _c("form", { staticStyle: { "padding-top": "35px" } }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "required", attrs: { for: "prizeName" } },
                      [_vm._v("Prize Name")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.prizeName,
                          expression: "prizeName"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "prizeName",
                        placeholder: "Gold or Bronze",
                        required: "true"
                      },
                      domProps: { value: _vm.prizeName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.prizeName = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "error-message" }, [
                      _vm._v(_vm._s(this.errors.emptyname))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "error-message" }, [
                      _vm._v(_vm._s(this.errors.lengthGreaterThanThirty))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "error-message" }, [
                      _vm._v(_vm._s(this.errors.invalidName))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "required", attrs: { for: "winners" } },
                      [_vm._v("Number of Winners")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.winnerCount,
                          expression: "winnerCount"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        min: "1",
                        max: "999",
                        step: "1",
                        maxlength: "3",
                        pattern: "\\d{3}",
                        id: "winners",
                        placeholder: "Between 1 - 999",
                        required: "true"
                      },
                      domProps: { value: _vm.winnerCount },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.winnerCount = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "error-message" }, [
                      _vm._v(_vm._s(this.errors.count))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "required",
                        attrs: { for: "attendeesDropdown" }
                      },
                      [_vm._v("Attendees List(s)")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "attendees-dropdown-container dropdown withInput"
                      },
                      [
                        _c("div", { attrs: { "data-toggle": "dropdown" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.listname,
                                expression: "listname"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "search",
                              id: "attendeesDropdown",
                              "aria-haspopup": "true",
                              "aria-expanded": "false"
                            },
                            domProps: { value: _vm.listname },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.listname = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "error-message" }, [
                            _vm._v(_vm._s(this.errors.lists))
                          ]),
                          _vm._v(" "),
                          _vm._m(0)
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dropdown-menu list-container",
                            attrs: { "aria-labelledby": "dropdownMenuButton" }
                          },
                          [
                            _c("div", { staticClass: "checkbox" }, [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.all_attendees,
                                      expression: "all_attendees"
                                    }
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    value: "all_attendees"
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.all_attendees)
                                      ? _vm._i(
                                          _vm.all_attendees,
                                          "all_attendees"
                                        ) > -1
                                      : _vm.all_attendees
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.all_attendees,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = "all_attendees",
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.all_attendees = $$a.concat([
                                              $$v
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.all_attendees = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.all_attendees = $$c
                                      }
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm.all_attendees.length > 0
                                  ? _c("img", {
                                      staticClass: "checkbox-square",
                                      attrs: {
                                        src: require("@/assets/images/square_check.svg")
                                      }
                                    })
                                  : _c("img", {
                                      staticClass: "checkbox-square",
                                      attrs: {
                                        src: require("@/assets/images/square_uncheck.svg")
                                      }
                                    }),
                                _vm._v(
                                  "\n                      All Attendees\n                    "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            this.static_lists.length > 0
                              ? _c("div", { staticClass: "list-section" }, [
                                  _vm._v("Static Lists")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.static_list_filter, function(list) {
                              return _c(
                                "div",
                                {
                                  key: "static_" + list._id,
                                  staticClass: "checkbox"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.display,
                                          expression: "display"
                                        }
                                      ]
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.static_selected,
                                            expression: "static_selected"
                                          }
                                        ],
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          value: list,
                                          checked: Array.isArray(
                                            _vm.static_selected
                                          )
                                            ? _vm._i(
                                                _vm.static_selected,
                                                list
                                              ) > -1
                                            : _vm.static_selected
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.static_selected,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = list,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.static_selected = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.static_selected = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.static_selected = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.static_selected.indexOf(list) == -1
                                        ? _c("img", {
                                            staticClass: "checkbox-square",
                                            attrs: {
                                              src: require("@/assets/images/square_uncheck.svg")
                                            }
                                          })
                                        : _c("img", {
                                            staticClass: "checkbox-square",
                                            attrs: {
                                              src: require("@/assets/images/square_check.svg")
                                            }
                                          }),
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(list.name) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            this.smart_lists.length > 0
                              ? _c("div", { staticClass: "list-section" }, [
                                  _vm._v("Smart Lists")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.smart_lists_filter, function(list) {
                              return _c(
                                "div",
                                {
                                  key: "smart_" + list._id,
                                  staticClass: "checkbox"
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.display,
                                          expression: "display"
                                        }
                                      ]
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.smart_selected,
                                            expression: "smart_selected"
                                          }
                                        ],
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          value: list,
                                          checked: Array.isArray(
                                            _vm.smart_selected
                                          )
                                            ? _vm._i(_vm.smart_selected, list) >
                                              -1
                                            : _vm.smart_selected
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a = _vm.smart_selected,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = list,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.smart_selected = $$a.concat(
                                                    [$$v]
                                                  ))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.smart_selected = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.smart_selected = $$c
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.smart_selected.indexOf(list) == -1
                                        ? _c("img", {
                                            staticClass: "checkbox-square",
                                            attrs: {
                                              src: require("@/assets/images/square_uncheck.svg")
                                            }
                                          })
                                        : _c("img", {
                                            staticClass: "checkbox-square",
                                            attrs: {
                                              src: require("@/assets/images/square_check.svg")
                                            }
                                          }),
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(list.name) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.all_attendees.length > 0
                  ? _c("div", { staticClass: "selected-list" }, [
                      _c("label", { staticClass: "text" }, [
                        _vm._v("All Attendees")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "clear",
                          on: {
                            click: function($event) {
                              return _vm.clearList(
                                "all attendees",
                                "toggle_all_attendees"
                              )
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/cancel.svg")
                            }
                          })
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.static_selected.length > 0
                  ? _c("label", { staticClass: "list-title" }, [
                      _vm._v("Static Lists")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "selected-lists-container" },
                  [
                    _vm._l(_vm.static_selected, function(static_list) {
                      return [
                        _c(
                          "div",
                          {
                            key: static_list._id,
                            staticClass: "selected-list"
                          },
                          [
                            _c("label", { staticClass: "text" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(static_list.name) +
                                  "\n                  "
                              ),
                              _c("span")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "clear",
                                on: {
                                  click: function($event) {
                                    return _vm.clearList(static_list, "static")
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/cancel.svg")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.smart_selected.length > 0
                  ? _c("label", { staticClass: "list-title" }, [
                      _vm._v("Smart Lists")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "selected-lists-container" },
                  [
                    _vm._l(_vm.smart_selected, function(smart_list) {
                      return [
                        _c(
                          "div",
                          { key: smart_list._id, staticClass: "selected-list" },
                          [
                            _c("label", { staticClass: "text" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(smart_list.name) +
                                  "\n                  "
                              ),
                              _c("span")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "clear",
                                on: {
                                  click: function($event) {
                                    return _vm.clearList(smart_list, "smart")
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/cancel.svg")
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group exclude-winners-group" }, [
                  _c("div", { staticClass: "toggle-row" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "toggle-switch",
                        attrs: { "aria-label": "Exclude previous winners" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.excludePreviousWinners,
                              expression: "excludePreviousWinners"
                            }
                          ],
                          staticClass: "toggle-input",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.excludePreviousWinners)
                              ? _vm._i(_vm.excludePreviousWinners, null) > -1
                              : _vm.excludePreviousWinners
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.excludePreviousWinners,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.excludePreviousWinners = $$a.concat([
                                      $$v
                                    ]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.excludePreviousWinners = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.excludePreviousWinners = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(2)
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "sub-option",
                      class: { visible: _vm.excludePreviousWinners },
                      attrs: { role: "group", "aria-label": "Exclusion scope" }
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("div", { staticClass: "radio-group" }, [
                        _c("label", { staticClass: "radio-option-row" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.exclusionScope,
                                expression: "exclusionScope"
                              }
                            ],
                            attrs: { type: "radio", value: "entire_draw" },
                            domProps: {
                              checked: _vm._q(_vm.exclusionScope, "entire_draw")
                            },
                            on: {
                              change: function($event) {
                                _vm.exclusionScope = "entire_draw"
                              }
                            }
                          }),
                          _vm._v(
                            "\n                  This entire lucky draw — exclude winners from all prizes\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "radio-option-row" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.exclusionScope,
                                expression: "exclusionScope"
                              }
                            ],
                            attrs: { type: "radio", value: "this_prize_only" },
                            domProps: {
                              checked: _vm._q(
                                _vm.exclusionScope,
                                "this_prize_only"
                              )
                            },
                            on: {
                              change: function($event) {
                                _vm.exclusionScope = "this_prize_only"
                              }
                            }
                          }),
                          _vm._v(
                            "\n                  This prize only — allow re-entry for other prizes\n                "
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mobile" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: {
                    click: function($event) {
                      return _vm.validate()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.prizeAction))]
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "caret-container" }, [
      _c("img", { attrs: { src: require("@/assets/images/caret.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "toggle-info" }, [
      _c("div", { staticClass: "toggle-label" }, [
        _vm._v("Exclude previous winners")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toggle-desc" }, [
        _vm._v(
          "Prevent anyone who has already won a prize in this lucky draw from being selected again."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "toggle-track" }, [
      _c("span", { staticClass: "toggle-thumb" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "sub-option-label" }, [
        _vm._v("Apply exclusion across")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sub-option-hint" }, [
        _vm._v(
          "Choose whether to exclude winners from this prize only or from the entire draw session."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43767376", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43767376","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreatePrize.vue
// module id = null
// module chunks = 